export interface AstLocation {
	offset?: number;
	tokLen?: number;
	file?: string;
	includedFrom?: unknown;
	spellingLoc?: AstLocation;
	expansionLoc?: AstLocation;
}
export interface AstNode {
	id?: string;
	previousDecl?: string;
	kind?: string;
	name?: string;
	loc?: AstLocation;
	range?: { begin: AstLocation; end: AstLocation };
	type?: { qualType: string; desugaredQualType?: string };
	storageClass?: string;
	init?: string;
	inner?: AstNode[];
	referencedDecl?: { id?: string; name?: string };
}
export interface SourceRange {
	from: number;
	to: number;
}
export interface VariableMetadata {
	id: number;
	name: string;
	type: string;
	canonicalType: string;
	initialized: boolean;
	global: boolean;
	sourceRanges: SourceRange[];
}
export interface DebugMetadata {
	checkpoints: { id: number; line: number; column: number }[];
	scopes: { id: number; functionName?: string }[];
	variables: VariableMetadata[];
	lineCount: number;
}
export interface DebugVariable extends VariableMetadata {
	key: string;
	address: number;
	byteSize: number;
	value: string;
	pointer?: number;
	changed: boolean;
}
export interface DebugFrame {
	id: number;
	name: string;
	line: number;
	variables: DebugVariable[];
}
export interface MemoryRegion {
	address: number;
	byteSize: number;
	label?: string;
}
export interface MemoryAccess extends MemoryRegion {
	read: boolean;
	write: boolean;
}
export interface DebugSnapshot {
	sequence: number;
	line: number;
	column: number;
	reason: 'step' | 'breakpoint';
	frames: DebugFrame[];
	globals: DebugVariable[];
	accesses: MemoryAccess[];
	accessesTruncated: boolean;
}
export type StepMode = 'into' | 'over' | 'out' | 'continue';

// This buffer is separate from C memory. Commands work even while the worker
// is blocked inside a synchronous WASM import and cannot handle postMessage.
export const CONTROL = {
	gate: 0,
	mode: 1,
	depth: 2,
	offset: 3,
	memoryRequest: 4,
	paused: 5,
	breakpoints: 6,
} as const;
export const GATE = { wait: 0, resume: 1, memory: 2 } as const;
export const MODE = { into: 0, over: 1, out: 2, continue: 3 } as const;

export function makeControl(metadata: DebugMetadata, breakpoints: number[]) {
	const control = new Int32Array(
		new SharedArrayBuffer((CONTROL.breakpoints + metadata.lineCount + 1) * 4),
	);
	Atomics.store(control, CONTROL.offset, 1024);
	updateBreakpoints(control, breakpoints);
	return control;
}
export function updateBreakpoints(control: Int32Array, lines: number[]) {
	const wanted = new Set(lines);
	for (let i = CONTROL.breakpoints; i < control.length; i++)
		Atomics.store(control, i, wanted.has(i - CONTROL.breakpoints) ? 1 : 0);
}
